import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/features/auth/auth-context'
import type { UserProfile } from '@/lib/types'

type Role = UserProfile['user']['role']

/** Where each role lands when it opens a page that belongs to another role. */
export function homeForRole(role: Role): string {
  if (role === 'admin') return '/admin/dashboard'
  return role === 'school_demo' || role === 'teacher' ? '/school' : '/home'
}

/** One role, or several (the school pages admit a teacher and a staff admin). */
export function RequireRole({ role }: { role: Role | readonly Role[] }) {
  const { profile } = useAuth()
  if (!profile) return <Navigate to="/login" replace />
  const allowed = typeof role === 'string' ? [role] : role
  if (!allowed.includes(profile.user.role)) return <Navigate to={homeForRole(profile.user.role)} replace />
  return <Outlet />
}
